<template>
  <div class="signup">
    <riseup-header/>
    <div class="more-info-div">
      <banner :on-banner-clicked="openMoreInfo">
        <template v-slot:content>
          <div class="content">
            <div>
              <div><img :src="require('@/assets/icons/star-white.svg')"/></div>
              <div class="text">חודש התנסות חינם לנרשמים עכשיו!</div>
            </div>
            <div><img :src="require('@/assets/icons/arrow_enabled_left.svg')" class="next-arrow"/></div>
          </div>
        </template>
      </banner>
    </div>

    <div class="intake-container">
      <div class="title">כמה פרטים ונרשמת!</div>
      <base-enter-details :action="nextStep"
                          :error="serverErrors.generateCode"
                          :reset-error="() => resetError('generateCode')"
                          button-title="הרשמה"/>
      <div class="action" v-on:click="goToLogin">
        כבר הצטרפת לשירות?
        <div class="action-link"> הכניסה מכאן</div>
      </div>
    </div>
  </div>
</template>

<script>
import EnterDetails from '@/base-components/EnterDetails';
import Banner from '@/base-components/Banner';
import RiseupHeader from '@/base-components/app-header/RiseupHeader.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import Segment from '@/Segment';
import BrowserInfo from '@/mixins/BrowserInfo';
import router from '@/router';
import TrialExplanationModal from './TrialExplanationModal';

export default {
  name: 'EnterDetails',
  mixins: [BrowserInfo],
  components: {
    RiseupHeader,
    BaseEnterDetails: EnterDetails,
    Banner,
  },
  props: {
    nextStep: {
      type: Function,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('RegistrationEntered_TrialInfoInPopup', { userAgentFromNavigator: this.userAgent, isFacebookApp: this.isFacebookApp });
    Segment.trackUserGotToPixel('RE_TrialInfoInPopup');
  },
  computed: {
    ...mapState('signup', ['serverErrors']),
  },
  methods: {
    ...mapMutations('signup', ['resetError']),
    ...mapActions('modalRootStore', ['openModal']),
    goToLogin() {
      Segment.trackUserInteraction('GoToLogin_TrialInfoInPopup');
      router.push({ path: '/sr', query: { ...this.$route.query, returning: true } });
    },
    openMoreInfo() {
      Segment.trackUserGot('TrialExplanationClicked');
      Segment.trackUserGotToPixel('TrialExplanationClicked');
      this.openModal({
        component: TrialExplanationModal,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '@/scss/mixins';

.signup {
  @include white-page-frame;

  .intake-container {
    color: $riseup_black;
    @include responsive-padding;

    .generate-code-button {
      width: 100%;
    }

    .title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 22px;
      line-height: 1.4;
      display: inline-block;
      width: 100%;
      margin-bottom: 32px;
    }

    .action {
      display: flex;
      justify-content: center;
      margin: 40px 0px;
      color: $riseup_black;
      font-size: 18px;
      line-height: 10px;
      .action-link {
        font-weight: bold;
        color: $riseup_blue;
        cursor: pointer;
        text-decoration: underline;
        margin-right: 5px;
      }
    }
  }

  .more-info-div {
    width: 100%;
    padding: 25px;

    .content {
      margin: 15px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      div {
        display: flex;
        align-content: space-between;
        justify-content: center;
        align-items: center;
      }

      .text {
        font-size: 16px;
        line-height: 24px;
        color: $riseup_black;
        font-family: SimplerPro;
        font-weight: bold;
        margin: 0px 10px;
      }

      img {
        display: block;
      }

      .next-arrow {
        width: 9px;
        height: 17px;
        // This fix the svg color to be $riseup_black, using https://codepen.io/sosuke/pen/Pjoqqp
        filter: invert(18%) sepia(15%) saturate(609%) hue-rotate(174deg) brightness(98%) contrast(95%);
      }
    }
  }
}

</style>
